
import React from "react";
import { usePageHeaderByKey } from "../hooks/usePageHeaderBykey";
import PublicPageShell from "./PublicPageShell";

const PrivacyPolicy = () => {
  const { pageHeader, isLoading } = usePageHeaderByKey("privacy-policy");

  if (isLoading) {
    return (
      <div className="flex h-screen justify-center items-center">
        <i className="pi pi-spin pi-spinner text-red-700" style={{ fontSize: '2rem' }}></i>
      </div>
    );
  }

  return (
    <PublicPageShell>
      <div className="flex flex-col justify-center w-full">
          {pageHeader?.h1 ? (
            <h1 className="text-2xl mb-4 text-center font-bold text-black uppercase">{pageHeader.h1}</h1>
          ) : (
            <h1 className="text-2xl mb-4 text-center font-bold text-black uppercase">Privacy Policy</h1>
          )}
          {pageHeader?.tagline && (
            <p className="mb-4 text-gray-700 md:text-sm leading-relaxed">
              {pageHeader.tagline}
            </p>
          )}

        {pageHeader?.content ? (
          <div 
            className="mb-4 text-gray-700 leading-relaxed md:text-sm"
            dangerouslySetInnerHTML={{ __html: pageHeader.content }}
          />
        ) : (
        <div>
          <section>
            <p className="text-gray-700 leading-relaxed mb-4 md:text-sm">
              This privacy policy (“policy”) will help you understand how American Realty Network LLC (“us”, “we”,
              “our”) uses and protects the data you provide to us when you visit and use of our website.  We reserve 
              the right to change this policy at any given time, of which will be promptly updated. If you want to 
              make sure that you are up to date with the latest changes, we advise you to frequently visit this page.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-800 mb-4">What User Data We Collect</h2>
            <p className="text-gray-700 leading-relaxed mb-4 md:text-sm">When you visit the website, we may collect the following data:</p>
            <ul className="list-disc list-inside text-gray-700 mb-4 md:text-sm">
              <li>Your IP address.</li>
              <li>Your contact information and email address.</li>
              <li>Other information such as interests and preferences.</li>
              <li>Data profile regarding your online behavior on our website.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-800 mb-4">Why We Collect Your Data</h2>
            <p className="text-gray-700 leading-relaxed mb-4 md:text-sm">We are collecting your data for several reasons:</p>
            <ul className="list-disc list-inside text-gray-700 mb-4 md:text-sm">
              <li>To better understand your needs.</li>
              <li>To improve our services and products.</li>
              <li>To send you promotional emails containing relevant information.</li>
              <li>To contact you for surveys and market research.</li>
              <li>To customize our website according to your preferences.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-800 mb-4">Safeguarding and Securing the Data</h2>
            <p className="text-gray-700 leading-relaxed mb-4 md:text-sm">
             American Realty Network LLC is committed to securing your data and keeping it confidential. American 
             Realty Network LLC has done all in its power to prevent data theft, unauthorized access, and disclosure 
             by implementing the latest technologies and software, which help us safeguard all the information 
             we collect online.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-800 mb-4">Our Cookie Policy</h2>
            <p className="text-gray-700 leading-relaxed mb-4 md:text-sm">
              Once you agree to allow our website to use cookies, you also agree to use the data it collects regarding 
              your online behavior (analyze web traffic, web pages you visit and spend the most time on). The data 
              we collect by using cookies is used to customize our website to your needs. After we use the data for 
              statistical analysis, the data is completely removed from our systems.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4 md:text-sm">
              Please note that cookies don’t allow us to gain control of your computer in any way. They are strictly 
              used to monitor which pages you find useful and which you do not so that we can provide a better 
              experience for you. If you want to disable cookies, you can do it by accessing the settings of your 
              internet browser.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-800 mb-4">Links to Other Websites</h2>
            <p className="text-gray-700 leading-relaxed mb-4 md:text-sm">
              Our website may contain links to other websites. American Realty Network LLC is not
              responsible for your data protection on external sites. We recommend reviewing their
              privacy policies.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-800 mb-4">
              Restricting the Collection of Your Personal Data
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4 md:text-sm">
              At some point, you might wish to restrict the use and collection of your personal data. You can achieve 
              this by doing the following: When you are filling the forms on the website, make sure to check if there is 
              a box which you can leave unchecked, if you don’t want to disclose your personal information.  If you 
              have already agreed to share your information with us, feel free to contact us via email and we will be 
              more than happy to change this for you.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4 md:text-sm">
              American Realty Network LLC will not lease, sell or distribute your personal information to any third 
              parties, unless we have your permission. We might do so if the law forces us. If you agree to this 
              privacy policy, we will store your personal information, we will use the information when we 
              communicate to you or when we send you informational and promotional materials.
            </p>
          </section>
        </div>
        )}
      </div>
    </PublicPageShell>
  );
};

export default PrivacyPolicy;
